import script from "./BaseCodeBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCodeBlock.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCodeBlock.vue?vue&type=style&index=0&id=35abf30a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35abf30a"]])

export default __exports__